<div class="d-flex card">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1">Checks</div>
		<div class="ms-auto">
			<p-button pRipple styleClass="p-button-raised p-button-secondary m-2" (click)="searchDisplay = !searchDisplay">
				<ng-template pTemplate="content">
					<div class="d-flex justify-content-center">
						<fa-icon [icon]="['far', 'magnifying-glass']" size="lg" class="ms-1 me-2"></fa-icon>
						Search
					</div>
				</ng-template>
			</p-button>
		</div>
	</div>
	<p-divider></p-divider>
	<p-table
		#dt
		styleClass="p-datatable-responsive-demo"
		[value]="checkList"
		[loading]="!checkList"
		[globalFilterFields]="app.keys(checkList)"
		[rowHover]="true"
		[rows]="10"
		[showCurrentPageReport]="true"
		[rowsPerPageOptions]="[10, 25, 50]"
		responsiveLayout="scroll"
		[paginator]="true"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} checks"
	>
		<ng-template pTemplate="caption">
			<div class="table-header d-flex">
				<div class="flex-grow-1 me-2">
					<span class="p-float-label p-input-icon-left m-2 w-100">
						<i class="pi pi-search"></i>
						<input
							pInputText
							class="w-100"
							id="globalSearch"
							name="globalSearch"
							style="width: 100%"
							type="text"
							(input)="dt.filterGlobal($event.target.value, 'contains')"
						/>
						<label for="globalSearch">Search...</label>
					</span>
				</div>
				<p-calendar
					styleClass="my-2 ms-2"
					appendTo="body"
					[(ngModel)]="businessDate"
					dateFormat="yy-mm-dd"
					(onSelect)="businessDateChange($event)"
				></p-calendar>
				<p-dropdown
					[options]="checkViewType"
					optionLabel="label"
					optionValue="value"
					name="checkViewType"
					(onChange)="changeCheckView($event)"
					[(ngModel)]="checkViewSelected"
					[style]="{ width: '100%' }"
					styleClass="m-2"
					appendTo="body"
				></p-dropdown>
			</div>
		</ng-template>
		<ng-template pTemplate="header">
			<tr>
				<th pSortableColumn="checkNumber">
					<div class="d-flex w-100">
						Check #
						<p-sortIcon field="checkNumber"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="numeric" field="checkNumber" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="table">
					<div class="d-flex w-100">
						Table
						<p-sortIcon field="table"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="text" field="table" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="timeOpened">
					<div class="d-flex w-100">
						Opened
						<p-sortIcon field="timeOpened"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="date" field="timeOpened" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="source">
					<div class="d-flex w-100">
						Source
						<p-sortIcon field="source"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="text" field="source" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="status">
					<div class="d-flex w-100">
						Status
						<p-sortIcon field="status"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="text" field="status" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="total">
					<div class="d-flex w-100">
						<fa-icon [icon]="['far', 'dollar']"></fa-icon>
						<p-sortIcon field="total"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="numeric" field="total" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="open">
					<div class="d-flex w-100">
						Open
						<p-sortIcon field="open"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="boolean" field="open" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
			</tr>
		</ng-template>
		<ng-template let-rec pTemplate="body">
			<tr>
				<td (click)="checkGet(venueKey, rec.checkKey)">
					<span class="p-column-title">Check #</span>
					{{ rec.checkNumber }}
				</td>
				<td (click)="checkGet(venueKey, rec.checkKey)">
					<span class="p-column-title">Table/Name</span>
					{{ rec.table }}
				</td>
				<td *ngIf="checkViewSelected === 'active'" (click)="checkGet(venueKey, rec.checkKey)">
					<span class="p-column-title">Opened</span>
					{{ moment(rec.timeOpened, 'MM/DD/YYYY HH:mm:ss').format('lll') }}
				</td>
				<td *ngIf="checkViewSelected === 'queue'" (click)="checkGet(venueKey, rec.checkKey)">
					<span class="p-column-title">Due Date</span>
					{{ moment(rec.dueDateTime).format('lll') }}
				</td>
				<td (click)="checkGet(venueKey, rec.checkKey)">
					<span class="p-column-title">Source</span>
					{{ rec.source }}
				</td>
				<td (click)="checkGet(venueKey, rec.checkKey)">
					<span class="p-column-title">Status</span>
					<span *ngIf="rec.status === 0">Queued</span>
					<span *ngIf="rec.status === 1 && rec.source === 'In-Store'">Saved</span>
					<span *ngIf="rec.status === 1 && rec.source !== 'In-Store'">Submitted</span>
					<span *ngIf="rec.status === 2">Error</span>
					<span *ngIf="rec.status === 3">Cancelled</span>
				</td>
				<td (click)="checkGet(venueKey, rec.checkKey)">
					<span class="p-column-title">Amount</span>
					{{ rec.total | currency }}
				</td>
				<td>
					<span class="p-column-title">Open</span>
					<fa-icon *ngIf="!rec.open" [icon]="['far', 'times-circle']" size="lg" class="ms-1"></fa-icon>
					<fa-icon *ngIf="rec.open" [icon]="['far', 'check-double']" size="lg" class="ms-1"></fa-icon>
					<p-button
						*ngIf="rec.futureOrder && rec.status === 0"
						pRipple
						styleClass="p-button-warning p-button-raised  m-2"
						(click)="sendOrder(rec.checkKey)"
					>
						<ng-template pTemplate="content">
							<fa-icon [icon]="['far', 'fast-forward']" size="lg" class="ms-1"></fa-icon>
						</ng-template>
					</p-button>
					<p-button *ngIf="rec.status === 0" pRipple styleClass="p-button-danger p-button-raised  m-2" (click)="cancelUnsentCheck(rec.checkKey)">
						<ng-template pTemplate="content">
							<fa-icon [icon]="['far', 'trash']" size="lg" class="ms-1"></fa-icon>
						</ng-template>
					</p-button>
				</td>
			</tr>
		</ng-template>
		<ng-template pTemplate="emptymessage">
			<tr>
				<td colspan="8" style="text-align: center">No checks found for {{ moment(businessDate, 'YYYY-MM-DD').format('l') }}.</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<p-sidebar [(visible)]="checkSelected" position="right" appendTo="body" (onHide)="checkSelected = undefined" [showCloseIcon]="false" styleClass="p-sidebar-md">
	<app-check-record-viewer *ngIf="checkSelected" [incomingCheck]="checkSelected"></app-check-record-viewer>
</p-sidebar>

<p-sidebar [(visible)]="searchDisplay" position="right" appendTo="body" (onHide)="checkSelected = undefined" [showCloseIcon]="false" styleClass="p-sidebar-md">
	<app-check-search *ngIf="searchDisplay" (checkQueryParamsChange)="searchForCheck($event)"></app-check-search>
</p-sidebar>
